module.exports = __webpack_public_path__ + "img/map_marker.6f50452c.png";